const headRowsVerification = {
  actions: 'Acciones',
  name: 'Grupo',
  alert: 'Generar Acción'
};

export default headRowsVerification;
